import { createFileRoute } from "@tanstack/react-router";
import { SupportPage } from "./support";

export const Route = createFileRoute("/en/support")({
  head: () => ({
    meta: [
      { title: "Help centre and support — Sellavo" },
      { name: "description", content: "Get help with listings, payments, accounts and safe deals on Sellavo." },
      { property: "og:title", content: "Help centre and support — Sellavo" },
      { property: "og:description", content: "Get help with listings, payments, accounts and safe deals on Sellavo." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/support" }],
  }),
  component: SupportPage,
});
